import React from "react";

const Contact = () => {
  return (
    <div name="contact" 
    id="Contact"
    className="w-full bg-gradient-to-b from-gray-800 to-black min-h-screen p-4 text-white ">
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
        <div className="pb-8">
          <p className="text-3xl md:text-4xl font-bold inline border-b-4 border-gray-500">Contact</p>
          <p className="py-4 md:py-6 text-sm md:text-lg">Sumbit the form if you would like to connect</p>
        </div>

        <div className="flex justify-center items-center">
          <form
            action="https://getform.io/f/e70a34cd-a2bc-46bf-be9c-5ef7756bcced"
            method="POST"
            className=" flex flex-col w-full md:w-1/2"
          >
            <input
              type="text"
              name="name"
              placeholder="Enter your name..."
              required
              className="p-2 mb-4 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              type="text"
              name="email"
              placeholder="Enter your email..."
              required
              className=" p-2 mb-4  bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <textarea
              name="message"
              rows="10"
              placeholder="Enter your message here......"
              required
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            ></textarea>
            <button
              className="text-white bg-gradient-to-b from-cyan-500 to-blue-500
           px-6 py-3 mt-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300 text-sm md:text-base"
            >
              Let's Connect
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
